import { EmbeddedVideo as EmbeddedVideoBlock } from '@/payload-types'
import Script from 'next/script'
import { CaptionComponent } from '@/components/media/caption'

interface IProps {
  embeddedVideoData: EmbeddedVideoBlock
}

export const EmbeddedVideo = ({ embeddedVideoData }: IProps) => {
  const videoSource = embeddedVideoData.source
  
  return (() => {
    switch (videoSource) {
      case 'vimeo':
        return (
          <div>
            <div className="pt-[56.25%] relative">
              <iframe
                src={`https://player.vimeo.com/video/${embeddedVideoData.videoId}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`}
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                className="absolute top-0 left-0 w-full h-full border-0 rounded-lg"
                title="Vimeo video"
              ></iframe>
            </div>
            <Script src="https://player.vimeo.com/api/player.js" integrity="sha512-HvslLWG3ypiz4IW+WhbrYQOtH7ylBx6oMq7a3ROg4YK2C3eQyrI896WETOFn2KQbpNrb8Du1A3EGyuSU+DDJBQ=="></Script>
            {embeddedVideoData.caption && (
              <CaptionComponent captionData={embeddedVideoData.caption} />
            )}
          </div>
        )
      default:
        return null
    }
  })()
}

export default EmbeddedVideo
